<template>
  <div class="bi-layout">
    <div
      v-if="adCampaigns"
      v-match-heights="{
        el: ['.bi-statistic-card', '.bi-statistic-card--body'] // Array of selectors to fix
      }"
      class="vx-row mb-16"
    >
      <div class="vx-col w-full">
        <h2>Kampagnen</h2>
      </div>
      <div class="vx-col w-full">
        <comparison-time-frame-input
          v-model="cardsTime"
          class="mb-4"
        ></comparison-time-frame-input>
      </div>
      <div class="vx-col lg:w-1/6">
        <div class="bi-statistic-card small">
          <div class="bi-statistic-card--content">
            <div class="bi-statistic-card--header">
              <span class="bi-statistic-card--icon">
                <i class="fas fa-newspaper"></i>
              </span>
            </div>
            <div class="bi-statistic-card--body">
              <h4 class="bi-statistic-card--number">{{ adCampaigns.total }}</h4>
              <h4 class="bi-statistic-card--title">Kampagnen</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col lg:w-1/6">
        <BiStatisticsCard
          icon="fa-euro-sign"
          data="cost"
          title="Ausgegebener Betrag"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
      <div class="vx-col lg:w-1/6">
        <BiStatisticsCard
          icon="fa-mouse"
          data="clicks"
          title="Klicks"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
      <div class="vx-col lg:w-1/6">
        <BiStatisticsCard
          icon="fa-eye"
          data="impressions"
          title="Impressionen"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
      <div class="vx-col lg:w-1/6">
        <BiStatisticsCard
          icon="fa-eye"
          data="applications"
          title="Bewerbungen"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
      <div class="vx-col lg:w-1/6">
        <BiStatisticsCard
          icon="fa-eye"
          data="costPerApplication"
          title="Kosten pro Bewerbung"
          small
          type="ALL"
          :limit-days="cardsTime.timeframe.from"
          :limit-stop="cardsTime.timeframe.to"
          :compare-start="cardsTime.compareTo.from"
          :compare-stop="cardsTime.compareTo.to"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-1/2">
        <h2>Alle Kampagnen</h2>
      </div>
      <div class="vx-col lg:w-1/2 text-right campaign-list--header-action">
        <button @click="openFilter = !openFilter">
          <i class="fas fa-filter"></i> Filter
        </button>
      </div>
      <div
        v-if="openFilter == true"
        class="vx-col w-full mb-10 campaign-list--filter"
      >
        <h4>Filter</h4>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/4">
            <DataInput
              v-model="filter.search"
              type="text"
              placeholder="Suche"
              class="w-full"
              name="search"
              label="Suche"
            />
          </div>
          <div class="vx-col w-full lg:w-1/4">
            <DataInput
              v-model="cardsTime.timeframe.from"
              type="date"
              label="Von"
              name="dateFrom"
              :config="{
                altFormat: 'd.m.Y H:i',
                dateFormat: 'Y-m-d H:i',
                enableTime: true,
                time_24hr: true
              }"
            />
          </div>
          <div class="vx-col w-full lg:w-1/4">
            <DataInput
              v-model="cardsTime.timeframe.to"
              type="date"
              label="Bis"
              name="dateUntil"
              :config="{
                altFormat: 'd.m.Y H:i',
                dateFormat: 'Y-m-d H:i',
                enableTime: true,
                time_24hr: true
              }"
            />
          </div>
          <div class="vx-col w-full lg:w-1/4">
            <DataInput
              v-model="filter.userGroup"
              type="model"
              label="Benutzergruppe"
              placeholder="Benutzergruppe"
              multiple
              name="group"
              gql-query="userGroups"
              allow-null
            />
          </div>
        </div>
      </div>
      <div class="vx-col w-full lg:mt-4">
        <template v-if="adCampaigns">
          <div class="campaign-list">
            <div
              v-for="campaign of adCampaigns.results"
              :key="campaign.id"
              class="campaign-list--item"
            >
              <div class="campaign-list--item-header">
                <div class="vx-row">
                  <div class="vx-col w-full lg:w-8/12">
                    <router-link
                      :to="{
                        name: 'bi.campaigns.edit',
                        params: { id: campaign.id }
                      }"
                      >{{ campaign.name }} <span>({{ campaign.number }})</span>
                    </router-link>
                  </div>
                  <div class="vx-col w-full lg:w-3/12 text-right">
                    <template v-if="campaign.facebookInsightsCount">
                      <span class="campaign-list--item-channel fb"
                        ><i class="fab fa-facebook-f"></i
                      ></span>
                      <!-- <span class="campaign-list--item-channel"
                        ><i class="fab fa-instagram"></i
                      ></span> -->
                    </template>
                    <span
                      v-if="campaign.cleverreachReportsCount"
                      class="campaign-list--item-channel cr"
                      ><i class="fal fa-mail-bulk"></i
                    ></span>
                    <span
                      v-if="campaign.googleAdsCount"
                      class="campaign-list--item-channel google"
                      ><i class="fab fa-google"></i
                    ></span>
                  </div>
                  <div class="vx-col w-full lg:w-1/12">
                    <div
                      class="campaign-delete cursor-pointer"
                      @click="confirmDeleteRecord(campaign.id)"
                    >
                      <feather-icon
                        icon="trash"
                        svg-classes="h-5 w-5 hover:text-danger"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="campaign-list--item-body">
                <div class="vx-row">
                  <div class="vx-col w-full lg:w-1/2">
                    <ul>
                      <li v-if="campaign.metrics">
                        <i class="fas fa-briefcase"></i>Bewerbungen:
                        <b>{{ campaign.metrics.applications || 0 }}</b>
                      </li>
                      <li v-if="campaign.metrics">
                        <i class="fas fa-briefcase"></i>Stellen:
                        <b>{{ campaign.metrics.vacancies || 0 }}</b>
                      </li>
                      <li v-if="campaign.metrics">
                        <i class="fas fa-chart-pie"></i>Aufrufe:
                        <b>{{ campaign.metrics.clicks || 0 }}</b>
                      </li>
                      <li v-if="campaign.metrics">
                        <i class="fas fa-eye"></i>Impressionen:
                        <b>{{ campaign.metrics.impressions || 0 }}</b>
                      </li>
                      <li v-if="campaign.dateStop">
                        <i class="fas fa-calendar"></i>Ende:
                        <b>{{ $d(new Date(campaign.dateStop), "short") }}</b>
                      </li>
                      <li v-if="campaign.metrics">
                        <i class="fas fa-money-bill"></i>
                        <b
                          >{{
                            (
                              campaign.metrics.spent /
                                campaign.metrics.applications || 0
                            ).toLocaleString(undefined, {
                              type: "currency",
                              currency: "EUR"
                            })
                          }}€/Bewerbung</b
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="vx-col w-full lg:w-1/2">
                    <div v-if="campaign.budget" class="vx-row">
                      <div class="vx-col w-full lg:w-3/5">
                        <div class="campaign-list--item-budget-progress">
                          <vs-progress
                            :percent="
                              Math.min(
                                100,
                                (campaign.metrics.spent / campaign.budget) * 100
                              )
                            "
                            color="primary"
                          ></vs-progress>
                        </div>
                        <div class="campaign-list--item-budget">
                          {{
                            Math.round(
                              (campaign.metrics.spent / campaign.budget) * 100
                            )
                          }}%
                        </div>
                      </div>
                      <div
                        v-if="campaign.vacancies.length"
                        class="vx-col w-full lg:w-2/5"
                      >
                        <VacancyStatVisitors
                          :numbers="campaign.vacancies.map(el => el.number)"
                        ></VacancyStatVisitors>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <vs-pagination
          v-if="adCampaigns"
          v-model="currentPage"
          :total="totalPages"
          :max="7"
          icon-pack="fas"
          prev-icon="fa-chevron-left"
          next-icon="fa-chevron-right"
        />
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import dataDefaults from "../../../../assets/utils/dataDefaults";
import { paginationMixin } from "@/mixins/paginationMixin.js";
import BiStatisticsCard from "@/components/bi/BiStatisticsCard.vue";
import DataInput from "@/components/ui/DataInput";
import VacancyStatVisitors from "../stats/VacancyStatVisitors";
import moment from "moment";
import ComparisonTimeFrameInput from "../../../../components/bi/ComparisonTimeFrameInput.vue";

export default {
  components: {
    BiStatisticsCard,
    DataInput,
    VacancyStatVisitors,
    ComparisonTimeFrameInput
  },
  mixins: [paginationMixin("adCampaigns")],
  data() {
    return {
      currentPage: 1,
      openFilter: false,
      filter: {
        search: null,
        vacancy: null,
        dateFrom: moment().subtract(30, "days"),
        dateUntil: moment(),
        userGroup: null
      },
      timeframe: "month",
      cardsTime: dataDefaults.timeFrameInput()
    };
  },
  apollo: {
    adCampaigns: {
      query: gql`
        query adCampaigns($page: Int!, $size: Int, $filter: AdCampaignFilter) {
          adCampaigns(page: $page, size: $size, filter: $filter) {
            total
            results {
              id
              number
              name
              dateStop
              budget
              metrics {
                spent
                clicks
                applications
                vacancies
                impressions
              }
              vacancies {
                id
                number
              }
              facebookInsightsCount
              cleverreachReportsCount
              googleAdsCount
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          page: Number(this.currentPage),
          size: Number(this.paginationPageSize),
          filter: {
            search: this.filter.search,
            dateFrom: this.cardsTime.timeframe.from,
            dateUntil: this.cardsTime.timeframe.to,
            userGroup: this.filter.userGroup
          }
        };
      }
    }
  },
  computed: {
    compareDuration() {
      return {
        day: 1,
        week: 7,
        month: 30,
        all: undefined
      }[this.timeframe];
    },
    compareStart() {
      return moment(this.dateMonth()).subtract(this.compareDuration, "days");
    },
    limitDays() {
      return moment(this.dateMonth());
    }
  },
  watch: {
    cardsTime: function() {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("matchheight", {}));
      }, 400);
    }
  },
  methods: {
    confirmDeleteRecord(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei eine Kampagne zu löschen. Wirklich löschen?`,
        accept: this.deleteRecord,
        acceptText: "Löschen"
      });
    },
    deleteRecord() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              deleteAdCampaign(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId
          }
        })
        .then(() => {
          this.showDeleteSuccess();
          // TODO: Workaround entfernen und Navigation neu laden lassen, dass der Filter sofort sichtbar wird
          setTimeout(() => {
            window.location.reload();
          }, 150);
        });
    },
    showDeleteSuccess() {
      this.deleteId = null;
      this.$vs.notify({
        color: "success",
        title: "Kampagne gelöscht",
        text: "Die ausgewählte Kampagne wurde gelöscht"
      });
    },
    dateMonth() {
      return this.cardsTime.timeframe.from || moment().subtract(30, "days");
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
